import React from "react";
import { useMutation } from "@apollo/client";
import { CREATE_INSURANCE_CARD } from "../../queries";
import useFamilyMembers from "../../hooks/useFamilyMembers";
import { FileData } from "@utils/fileUtils";
import { logEvent } from "@actions";
import AddInsuranceCard from "./AddInsuranceCard";

type Props = {
  onContinuePress: (cardAdded: boolean) => void;
  required?: boolean;
  logEventParams?: object;
  headerComponent?: React.ReactNode;
};

export default function AddInsuranceCardBilling({ onContinuePress, required, logEventParams, headerComponent }: Props) {
  const [createInsuranceCardMutation] = useMutation(CREATE_INSURANCE_CARD);
  const { userAndChildren } = useFamilyMembers();

  const handleSubmitCard = async (front: FileData, back: FileData | null) => {
    logEvent("addInsuranceCardSubmitted", logEventParams);
    await createInsuranceCardMutation({
      variables: {
        userIds: userAndChildren.map(member => member.id),
        frontImage: front,
        backImage: back
      }
    });
    onContinuePress(true);
  };

  const handleSkip = required
    ? undefined
    : () => {
        logEvent("addInsuranceCardLater", logEventParams);
        onContinuePress(false);
      };

  return (
    <AddInsuranceCard
      onSubmitCard={handleSubmitCard}
      onSkip={handleSkip}
      skipLabel="I'll do this later"
      headerComponent={headerComponent}
    />
  );
}
